import { render, staticRenderFns } from "./PhotoAlbumn.vue?vue&type=template&id=63e209e7&scoped=true"
import script from "./PhotoAlbumn.vue?vue&type=script&lang=js"
export * from "./PhotoAlbumn.vue?vue&type=script&lang=js"
import style0 from "./PhotoAlbumn.vue?vue&type=style&index=0&id=63e209e7&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e209e7",
  null
  
)

export default component.exports